import { render, staticRenderFns } from "./SidebarCart.vue?vue&type=template&id=5779f514&scoped=true"
import script from "./SidebarCart.vue?vue&type=script&lang=js"
export * from "./SidebarCart.vue?vue&type=script&lang=js"
import style0 from "./SidebarCart.vue?vue&type=style&index=0&id=5779f514&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5779f514",
  null
  
)

export default component.exports